import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from './App'; // Main application component
import RegistrationPage from './pages/signup'; // Main application component
import LinkLineConnectPage from './pages/linkgameid'; // Main application component
import LicenseAgreement from './pages/terms'; // Main application component
import VerifyIDPage from './pages/verifygameid'; // Main application component
import QRPromptPay from './pages/qrpromtpay'; // Main application component
import ItemCodePage from './pages/itemcode'; // Main application component
import TopupEventPage from './pages/topupevent'; // Main application component
import SummaryItemEvent22To28 from './pages/summaryitemevent'; // Main application component

const MainApp = () => {
  return (
    <Routes>
      {/* Define your routes here */}
      <Route path="/" element={<App />} />
      <Route path="/signup" element={<RegistrationPage />} />
      <Route path="/verifyid" element={<VerifyIDPage />} />
      <Route path="/terms" element={<LicenseAgreement />} />
      <Route path="/linklineconnect" element={<LinkLineConnectPage />} />
      <Route path="/qrpromptpay" element={<QRPromptPay />} />
      <Route path="/itemcode" element={<ItemCodePage />} />
      <Route path="/topupevent" element={<TopupEventPage />} />
      <Route path="/itemsummaryevent" element={<SummaryItemEvent22To28 />} />
    </Routes>
  );
};

export default MainApp;
